import React from 'react'
import { type Effect, LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/opacity.css'

export interface PlayerImageProps {
  height?: string | number
  width?: string | number
  src: string | undefined
  alt?: string
  effect?: Effect | undefined
}

export const TeamImage: React.FC<PlayerImageProps> = ({ alt, src, height, width, effect }) => {
  return <LazyLoadImage
    alt={alt}
    loading='lazy'
    effect={'opacity'}
    wrapperProps={{
      style: { transitionDelay: '0.125s' }
    }}
    style={
      {
        height: height ?? 'calc(0.75dvw + 64px)',
        width: width ?? 'calc(0.75dvw + 64px)'
      }
    }
    placeholderSrc={src}
    src={src}
     />
}

export default React.memo(TeamImage)
